module.exports = __webpack_public_path__ + "assets/img/b6eab0f8fbc51f41c04b918b16a417f6.svg";